import { render, staticRenderFns } from "./NewFeatureEditor.vue?vue&type=template&id=40267bc6&scoped=true&"
import script from "./NewFeatureEditor.vue?vue&type=script&lang=js&"
export * from "./NewFeatureEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewFeatureEditor.vue?vue&type=style&index=0&id=40267bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40267bc6",
  null
  
)

export default component.exports